import script from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\VAffix.vue?type=script"
export * from "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\VAffix.vue?type=script"

import "D:\\Kryzalis\\proquimil.com.br-2023\\frontend\\src\\assets\\js\\components\\VAffix.vue?type=style&index=0"
export default script